import ClipboardData from './clipboardData';

export default class PasteEvent {
  constructor() {
    this.clipboardData = new ClipboardData();
  }
}



// WEBPACK FOOTER //
// node_modules/@reactual/handsontable/src/plugins/copyPaste/pasteEvent.js